<template lang="pug">
  div
    promo-aggregator-header(
      :delivery-platform="item.delivery_platform"
      :first-promo="item.first_promo"
      :is-collapse="isCollapse"
      :max-centers="item.max_centers"
      :menu-items="item.menu_items"
      :promo="item.promo"
      :is-competitor="isCompetitor"
      @click="$emit('collapsePromo')"
    )
    div(v-if="item.menu_items.length >= 2")
      promo-item-menu(:item-menu="item.menu_items[0]" @click="$emit('showDetailsMenuItem', item.menu_items[0])")
      div.d-flex.justify-center.bodyAggregatorPromotions.w-full.py-2.cursor-pointer(v-if="isCollapse" @click="$emit('collapsePromo')")
        h4 ...
      v-expand-transition
        div(v-show="!isCollapse")
          div(v-for="(itemMenu, indexMenu) in item.menu_items")
            promo-item-menu(v-if="indexMenu !== 0" :item-menu="itemMenu" @click="$emit('showDetailsMenuItem', itemMenu)")
    div(v-else-if="item.menu_items.length > 0")
      div(v-for="(itemMenu, indexMenu) in item.menu_items")
        promo-item-menu(:item-menu="itemMenu" @click="$emit('showDetailsMenuItem', itemMenu)")
</template>

<script>
import PromoAggregatorHeader from "./PromoAggregatorHeader.vue"
import PromoItemMenu from "./PromoItemMenu.vue"
export default {
  name: 'PromoCollapse',
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    },
    isCompetitor: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    PromoAggregatorHeader,
    PromoItemMenu
  }

}
</script>

<style lang="scss" scoped>
.bodyAggregatorPromotions{
  border-top:1px solid #D9DFE8;
}
</style>
